import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';

//Actions
import * as ordersActions from '../../actions/ordersActions';
import ExportOrders from '../../components/ExportOrders';

import OrdersInner from './ordersInner';

class SettledTrades extends React.Component {
    constructor(props) {
		super(props);
        this.props.actions.getOrders('settledTrades');
	}

    componentDidMount() {
        const { isLoggedIn } = this.props.user;
        // if (!isLoggedIn) browserHistory.push('/');
    }

    render() {
        const { isSuperUser } = this.props.user;

        return (
            <div>
                <h1>Your settled trades</h1>
                <h3>These are the done and settled orders currently in the system from users from your company.</h3>
                <ExportOrders path="allsettledorders" />
                <OrdersInner {...this.props} mode={isSuperUser ? 'edit-finalised' : 'view'} showCounerparty={true} />
            </div>

        )
    }
}

export default connect(
    state => ({
        orders: state.orders,
        user: state.user,
    }),
    dispatch => ({
        actions: bindActionCreators({...ordersActions}, dispatch)
    })
)(SettledTrades);



// WEBPACK FOOTER //
// ./source/screens/orders/settledTrades.js